import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router'
import { ExperimentationService } from '../shared/experimentation/experimentation.service'
import {
  EXP_CHOOSE_FAVORITES_VARIATION,
  EXP_NEXT_GEN_EVENT_HUB_WRESTLING
} from '../shared/experimentation/experiment.model'
import { catchError, map, Observable, of } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class NextGenEventHubGuard implements CanActivate {
  constructor(private experimentService: ExperimentationService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.experimentService
      .isInVariation(EXP_NEXT_GEN_EVENT_HUB_WRESTLING, EXP_CHOOSE_FAVORITES_VARIATION, true)
      .pipe(
        map(isInExperiment => {
          if (isInExperiment) {
            const strippedUrl = state.url.match(/^\/events\/\d+/)?.[0] || state.url
            return this.router.createUrlTree([`/nextgen${strippedUrl}/information`])
          }
          return true // Allow navigation
        }),
        catchError(err => {
          console.error('Error in event-hub guard', err)
          return of(false)
        })
      )
  }
}
